import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from './gtm';

const GTMPageViews = () => {
  const location = useLocation();
  const lastPathRef = useRef<string | null>(null);

  useEffect(() => {
    const path = `${location.pathname}${location.search}`;
    if (lastPathRef.current === path) {
      return;
    }

    lastPathRef.current = path;
    trackPageView(path, document.title);
  }, [location.pathname, location.search]);

  return null;
};

export default GTMPageViews;
